import React from "react";
const PlayIcon = props => {
    return <svg width="48" height="48"  viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle opacity="0.9" cx="24" cy="24" r="24" fill="white" />
        <path d="M34.4023 24L18.8023 33.0066L18.8023 14.9933L34.4023 24Z" fill="black" fillOpacity="0.8" />
    </svg>

}

export default PlayIcon;